export default __webpack_public_path__ + "static/media/timeline-area-chart.3d134a05.svg";